import { createAction } from '@reduxjs/toolkit';

export const canvasActionType = {
  UPDATE_PREV_TEXT_DICT: 'UPDATE_PREV_TEXT_DICT',
  UPDATE_LAST_UNDO_TEXT: 'UPDATE_LAST_UNDO_TEXT',
  UPDATE_FIRST_UNDO_TEXT: 'UPDATE_FIRST_UNDO_TEXT',
  PUSH_TO_UNDO_STACK: 'PUSH_TO_UNDO_STACK',
  CHANGE_UNDO_REDO_LIST: 'CHANGE_UNDO_REDO_LIST',
  CLEAR_UNDO_REDO: 'CLEAR_UNDO_REDO',
  SET_UI_OBJECT: 'SET_UI_OBJECT',
  SET_IMAGE_DICT: 'SET_IMAGE_DICT',
  SET_TEXT_DICT: 'SET_TEXT_DICT',
  SET_SELECTING_TEMPLATE_FLAG: 'SET_SELECTING_TEMPLATE_FLAG',
  SET_CUSTOM_BACKGROUND_DICT: 'SET_CUSTOM_BACKGROUND_DICT',
  SET_RECENTART_DICT: 'SET_RECENTART_DICT',
  SET_STOCKART_DICT: 'SET_STOCKART_DICT',
  SET_SAVEDART_DICT: 'SET_SAVEDART_DICT',
  SET_SHAREDART_DICT: 'SET_SHAREDART_DICT',
  CHANGE_IMAGE_UI_STATUS: 'CHANGE_IMAGE_UI_STATUS',
  SET_CANVAS_ELEMENT_HIGHLIGHT: 'SET_CANVAS_ELEMENT_HIGHLIGHT',
  ADD_NEW_LOGO: 'ADD_NEW_LOGO',
  UPDATE_CANVAS_IMAGE: 'UPDATE_CANVAS_IMAGE',
  CHANGE_CROPRECT: 'CHANGE_CROPRECT',
  CHANGE_CANVASTAB_INDEX: 'CHANGE_CANVASTAB_INDEX',
  INIT_CANVAS: 'INIT_CANVAS',
  INIT_IMAGE_DICT: 'INIT_IMAGE_DICT',
  INIT_TEXT: 'INIT_TEXT',
  SELECT_IMAGE: 'SELECT_IMAGE',
  SELECT_TEXT: 'SELECT_TEXT',
  RETURN_SELECT_TEXT: 'RETURN_SELECT_TEXT',
  BATCH_SELECT_IMAGE: 'BATCH_SELECT_IMAGE',
  BATCH_SELECT_TEXT: 'BATCH_SELECT_TEXT',
  RETURN_BATCH_SELECT_TEXT: 'RETURN_BATCH_SELECT_TEXT',
  UNSELECT_IMAGE: 'UNSELECT_IMAGE',
  UNSELECT_TEXT: 'UNSELECT_TEXT',
  UNSELECT_ALL_IMAGE: 'UNSELECT_ALL_IMAGE',
  UNSELECT_ALL_TEXT: 'UNSELECT_ALL_TEXT',
  RETURN_UNSELECT_ALL_TEXT: 'RETURN_UNSELECT_ALL_TEXT',
  CHANGE_SELECTED_TEXT_STATUS_TO_TEMP: 'CHANGE_SELECTED_TEXT_STATUS_TO_TEMP',
  CHANGE_ALL_TEXT_STATUS_TO_TEMP: 'CHANGE_ALL_TEXT_STATUS_TO_TEMP',
  SET_DRAG_FLAG: 'SET_DRAG_FLAG',
  ADD_TEMP: 'ADD_TEMP',
  ADD_ART: 'ADD_ART',
  CANCEL_SELECT_ART: 'CANCEL_SELECT_ART',
  CHANGE_IMAGE_POSITION: 'CHANGE_IMAGE_POSITION',
  CHANGE_TEXT_POSITION: 'CHANGE_TEXT_POSITION',
  CHANGE_IMAGE_SIZE: 'CHANGE_IMAGE_SIZE',
  CHANGE_DIRECTION: 'CHANGE_DIRECTION',
  CHANGE_TO_TEMP: 'CHANGETO_TEMP',
  ADD_ROTATE_IMAGE: 'ADD_ROTATE_IMAGE',
  DELETE_IMAGE: 'DELETE_IMAGE',
  DELETE_TEXT: 'DELETE_TEXT',
  LAYER_UP: 'LAYER_UP',
  LAYER_DOWN: 'LAYER_DOWN',
  CHANGE_ART_COLOR: 'CHANGE_ART_COLOR',
  INIT_BACKGROUND: 'INIT_BACKGROUND',
  ADD_BACKGROUND_IMAGE: 'ADD_BACKGROUND_IMAGE',
  REMOVE_BACKGROUND_IMAGE: 'REMOVE_BACKGROUND_IMAGE',
  ADD_INIT_IMAGE_ELEMENTS: 'ADD_INIT_IMAGE_ELEMENTS',
  UPDATE_ELEMENT_DIMENSION: 'UPDATE_ELEMENT_DIMENSION',
  CENTER_IAMGE: 'CENTER_IAMGE',
  SET_IMAGE_ELEMENT_CLONE: 'SET_IMAGE_ELEMENT_CLONE',
  CHANGE_CANVAS_RESIZE: 'CHANGE_CANVAS_RESIZE',
  SET_ITEMSTYIE_ORIGIN_SIZE: 'SET_ITEMSTYIE_ORIGIN_SIZE',
  CHANGE_LOGO_DIRECTION: 'CHANGE_LOGO_DIRECTION',
  DELETE_EXISTING_LOGO_ART: 'DELETE_EXISTING_LOGO_ART',
  SELECT_IMAGE_FOR_NONDIGITAL: 'SELECT_IMAGE_FOR_NONDIGITAL',
  CHANGE_SLOGAN_YEAR: 'CHANGE_SLOGAN_YEAR',
  CHANGE_LOGO_COLORS: 'CHANGE_IMAGE_COLORS',
  SAVE_IMAGE_ORIGIN_COLORS: 'SAVE_IMAGE_ORIGIN_COLORS',
  SET_COLORIZE_FLAG: 'SET_COLORIZE_FLAG',
  SET_IMAGE_UI: 'SET_IMAGE_UI',
  CHANGE_ALL_TEXT_COLOR_NON_DIGITAL: 'CHANGE_ALL_TEXT_COLOR_NON_DIGITAL',
  CHANGE_LOGO_STATUS: 'CHANGE_LOGO_STATUS',
  UPDATE_ELEMENT_BY_STATUS: 'UPDATE_ELEMENT_BY_STATUS',
  SWITCH_SHOW_LEGAL_DISTANCE_WARNING: 'SWITCH_SHOW_LEGAL_DISTANCE_WARNING',
  DELETE_SAVEDART_IMAGE: 'DELETE_SAVEDART_IMAGE',
  CHANGE_CROP_PARAMETER: 'CHANGE_CROP_PARAMETER',
  RESET_UPLOAD_IMAGE_OPTIONS: 'RESET_UPLOAD_IMAGE_OPTIONS',
  CHANGE_FONT_STYLE: 'CHANGE_FONT_STYLE',
  ADD_ART_FOR_LITE: 'ADD_ART_FOR_LITE',
  CLEAR_IMAGE_DICT: ' CLEAR_IMAGE_DICT',
  STORE_SHARPEN_INFO: ' STORE_SHARPEN_INFO',
  CHANGE_TO_SHARPENED: ' CHANGE_TO_SHARPENED',
  CHANGE_TO_UNSHARPENED: ' CHANGE_TO_UNSHARPENED',
  CHANGE_SHARPENED_MESSAGE_STATUS: 'CHANGE_SHARPENED_MESSAGE_STATUS',
  COPY_IMAGE_ELEMENT: 'COPY_IMAGE_ELEMENT',
  COPY_TEXT_ELEMENT: 'COPY_TEXT_ELEMENT',
  SET_IS_EDITING_TEXT: 'SET_IS_EDITING_TEXT',
  SET_EDITING_TEXT_INPUT_STATE: 'SET_EDITING_TEXT_INPUT_STATE',
  SET_EDITING_TEXT_SYMBOLS: 'SET_EDITING_TEXT_SYMBOLS',
  SET_MAX_AVAILABLE_FONT_SIZE: 'SET_MAX_AVAILABLE_FONT_SIZE',
  SET_ROTATE_START: 'SET_ROTATE_START',
  SET_ROTATE_ANGLE: 'SET_ROTATE_ANGLE',
};

export const updatePrevTextDict = createAction(canvasActionType.UPDATE_PREV_TEXT_DICT);
export const updateLastUndoText = createAction(canvasActionType.UPDATE_LAST_UNDO_TEXT);
export const updateFirstUndoText = createAction(canvasActionType.UPDATE_FIRST_UNDO_TEXT);
export const pushToUndoStack = createAction(canvasActionType.PUSH_TO_UNDO_STACK);
export const changeUndoRedoList = createAction(canvasActionType.CHANGE_UNDO_REDO_LIST);
export const clearUndoRedo = createAction(canvasActionType.CLEAR_UNDO_REDO);
export const setUi = createAction(canvasActionType.SET_UI_OBJECT);
export const setImageDict = createAction(canvasActionType.SET_IMAGE_DICT);
export const setTextDict = createAction(canvasActionType.SET_TEXT_DICT);
export const setSelectingTemplateFlag = createAction(canvasActionType.SET_SELECTING_TEMPLATE_FLAG);
export const setCustomBackgroundDict = createAction(canvasActionType.SET_CUSTOM_BACKGROUND_DICT);
export const setRecentArtDict = createAction(canvasActionType.SET_RECENTART_DICT);
export const setStockArtDict = createAction(canvasActionType.SET_STOCKART_DICT);
export const setSavedArtDict = createAction(canvasActionType.SET_SAVEDART_DICT);
export const setSharedArtDict = createAction(canvasActionType.SET_SHAREDART_DICT);
export const setCanvasElementHighlight = createAction(canvasActionType.SET_CANVAS_ELEMENT_HIGHLIGHT);
export const addNewLogo = createAction(canvasActionType.ADD_NEW_LOGO);
export const updateCanvasImage = createAction(canvasActionType.UPDATE_CANVAS_IMAGE);
export const changeCropRect = createAction(canvasActionType.CHANGE_CROPRECT);
export const changeImagePosition = createAction(canvasActionType.CHANGE_IMAGE_POSITION);
export const changeImageSize = createAction(canvasActionType.CHANGE_IMAGE_SIZE);
export const changeTextPosition = createAction(canvasActionType.CHANGE_TEXT_POSITION);
export const initCanvas = createAction(canvasActionType.INIT_CANVAS);
export const initImageDict = createAction(canvasActionType.INIT_IMAGE_DICT);
export const initText = createAction(canvasActionType.INIT_TEXT);
export const selectImage = createAction(canvasActionType.SELECT_IMAGE);
export const selectText = createAction(canvasActionType.SELECT_TEXT);
export const returnSelectText = createAction(canvasActionType.RETURN_SELECT_TEXT);
export const batchSelectImage = createAction(canvasActionType.BATCH_SELECT_IMAGE);
export const batchSelectText = createAction(canvasActionType.BATCH_SELECT_TEXT);
export const returnBatchSelectText = createAction(canvasActionType.RETURN_BATCH_SELECT_TEXT);
export const unSelectImage = createAction(canvasActionType.UNSELECT_IMAGE);
export const unSelectText = createAction(canvasActionType.UNSELECT_TEXT);
export const unSelectAllImage = createAction(canvasActionType.UNSELECT_ALL_IMAGE);
export const unSelectAllText = createAction(canvasActionType.UNSELECT_ALL_TEXT);
export const returnUnSelectAllText = createAction(canvasActionType.RETURN_UNSELECT_ALL_TEXT);
export const changeSelectedTextStatusToTemp = createAction(canvasActionType.CHANGE_SELECTED_TEXT_STATUS_TO_TEMP);
export const changeAllTextStatusToTemp = createAction(canvasActionType.CHANGE_ALL_TEXT_STATUS_TO_TEMP);
export const addTemp = createAction(canvasActionType.ADD_TEMP);
export const addArt = createAction(canvasActionType.ADD_ART);
export const cancelSelectArt = createAction(canvasActionType.CANCEL_SELECT_ART);
export const changeStatusFromSelectedToTemp = createAction(canvasActionType.CHANGE_TO_TEMP);
export const deleteImage = createAction(canvasActionType.DELETE_IMAGE);
export const deleteText = createAction(canvasActionType.DELETE_TEXT);
export const layerUp = createAction(canvasActionType.LAYER_UP);
export const layerDown = createAction(canvasActionType.LAYER_DOWN);
export const changeArtColor = createAction(canvasActionType.CHANGE_ART_COLOR);
export const initBackground = createAction(canvasActionType.INIT_BACKGROUND);
export const addBackgroundImage = createAction(canvasActionType.ADD_BACKGROUND_IMAGE);
export const removeBackgroundImage = createAction(canvasActionType.REMOVE_BACKGROUND_IMAGE);
export const addInitImageElements = createAction(canvasActionType.ADD_INIT_IMAGE_ELEMENTS);
export const updateElementDimension = createAction(canvasActionType.UPDATE_ELEMENT_DIMENSION);
export const setImageElementClone = createAction(canvasActionType.SET_IMAGE_ELEMENT_CLONE);
export const changeElementHorizonAlign = createAction('changeElementHorizonAlign');
export const changeElementVerticalAlign = createAction('changeElementVerticalAlign');
export const resizeElement = createAction('resizeElement');
export const changeCanvasResizeParameters = createAction(canvasActionType.CHANGE_CANVAS_RESIZE);
export const setItemStyleOriginSize = createAction(canvasActionType.SET_ITEMSTYIE_ORIGIN_SIZE);
export const changeDirection = createAction(canvasActionType.CHANGE_LOGO_DIRECTION);
export const selectImageForNonDigital = createAction(canvasActionType.SELECT_IMAGE_FOR_NONDIGITAL);
export const deleteExistingLogoArt = createAction(canvasActionType.DELETE_EXISTING_LOGO_ART);
export const changeSloganYear = createAction(canvasActionType.CHANGE_SLOGAN_YEAR);
export const changeLogoColors = createAction(canvasActionType.CHANGE_LOGO_COLORS);
export const saveImageOriginColors = createAction(canvasActionType.SAVE_IMAGE_ORIGIN_COLORS);
export const setColorizeFlag = createAction(canvasActionType.SET_COLORIZE_FLAG);
export const setImageUI = createAction(canvasActionType.SET_IMAGE_UI);
export const changeAllTextColorNonDigital = createAction(canvasActionType.CHANGE_ALL_TEXT_COLOR_NON_DIGITAL);
export const changeLogoStatus = createAction(canvasActionType.CHANGE_LOGO_STATUS);
export const updateElementByStatus = createAction(canvasActionType.UPDATE_ELEMENT_BY_STATUS);
export const deleteSavedArtImage = createAction(canvasActionType.DELETE_SAVEDART_IMAGE);
export const changeCropParameter = createAction(canvasActionType.CHANGE_CROP_PARAMETER);
export const resetUploadImageOptions = createAction(canvasActionType.RESET_UPLOAD_IMAGE_OPTIONS);
export const changeFontStyle = createAction(canvasActionType.CHANGE_FONT_STYLE);
export const addArtForLite = createAction(canvasActionType.ADD_ART_FOR_LITE);
export const switchAskIfUserNeedImprintOption = createAction('SWITCH_ASK_IF_USER_NEED_IMPRINT_OPTION');
export const clearImageDict = createAction(canvasActionType.CLEAR_IMAGE_DICT);
export const changeToSharpened = createAction(canvasActionType.CHANGE_TO_SHARPENED);
export const changeToUnsharpened = createAction(canvasActionType.CHANGE_TO_UNSHARPENED);
export const changeSharpenMessageStatus = createAction(canvasActionType.CHANGE_SHARPENED_MESSAGE_STATUS);
export const changeImageUiStatus = createAction(canvasActionType.CHANGE_IMAGE_UI_STATUS);
export const copyImageElement = createAction(canvasActionType.COPY_IMAGE_ELEMENT);
export const copyTextElement = createAction(canvasActionType.COPY_TEXT_ELEMENT);
export const setIsEditingText = createAction(canvasActionType.SET_IS_EDITING_TEXT);
export const setEditingTextInputState = createAction(canvasActionType.SET_EDITING_TEXT_INPUT_STATE);
export const setEditingTextSymbols = createAction(canvasActionType.SET_EDITING_TEXT_SYMBOLS);
export const applyArt = createAction('imageDict/applyArt');
export const setMaxAvailableFontSize = createAction(canvasActionType.SET_MAX_AVAILABLE_FONT_SIZE);
export const setRotateStart = createAction(canvasActionType.SET_ROTATE_START);
export const setRotateAngle = createAction(canvasActionType.SET_ROTATE_ANGLE);
export const setImageListByImprintAreaKeyAction = createAction('imageDict/setImageListByImprintAreaKey');
export const setTextListByImprintAreaKeyAction = createAction('textDict/setTextListByImprintAreaKey');
